import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';

export const useGetExternalDetails = () => {
  return useMutation({
    mutationFn: async ({ backendUrl, params }) => {
      if (!backendUrl) {
        throw new Error('backendUrl is required');
      }

      const response = await axios.get(`${HOST}${backendUrl}`, { params });
      return response.data;
    },
  });
};
